import { constantTree } from "../../../core/events/ConstantTree";

export const cookieTree = constantTree({
    Consent: {
        Accept: {
            All: "",
            Necessary: ""
        },
        Manage: {
            Settings: {
                Open: "",
                Close: ""
            }
        },
        Save: {
            Preferences: ""
        }
    }
}); 